export const projects = [
  {
    id: "box-hill-institute-lilydale",
    image: "/assets/images/projects/box-hill-institute-lilydale/default.jpeg",
    images: [
      "/assets/images/projects/box-hill-institute-lilydale/1.jpeg",
      "/assets/images/projects/box-hill-institute-lilydale/2.jpeg",
      "/assets/images/projects/box-hill-institute-lilydale/3.jpeg",
      "/assets/images/projects/box-hill-institute-lilydale/4.jpeg",
      "/assets/images/projects/box-hill-institute-lilydale/5.jpeg",
      "/assets/images/projects/box-hill-institute-lilydale/6.jpeg",
    ],
    title: "Box Hill Institute Lilydale Cleaning",
    description:
      "At Clear Choice, we are proud to provide daily cleaning services for Box Hill Institute Lilydale, ensuring a pristine and welcoming environment for students, staff, and visitors.",
    subtitle:
      "Our dedicated team delivers a comprehensive range of cleaning tasks, including:",
    tasks: [
      {
        task: "General Cleaning",
        description: "Keeping all spaces tidy and well-maintained.",
      },
      {
        task: "Vacuuming and Mopping",
        description:
          "Ensuring clean and polished floors throughout the institute.",
      },
      {
        task: "Surface Wiping",
        description:
          "Sanitizing desks, countertops, and frequently touched areas.",
      },
      {
        task: "Bowl Cleaning",
        description: "Maintaining hygienic and spotless restroom facilities.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "Ensuring clean and functional kitchen spaces for staff and students.",
      },
      {
        task: "Sweeping",
        description: "Keeping outdoor and high-traffic areas clear of debris.",
      },
      {
        task: "Collecting Bins",
        description:
          "Emptying and sanitizing bins to promote cleanliness and waste management.",
      },
      {
        task: "Window Cleaning",
        description:
          "Delivering streak-free windows for a bright and inviting atmosphere.",
      },
    ],
    bottomText:
      "With our commitment to excellence, we help Box Hill Institute Lilydale maintain a clean, productive, and inspiring learning environment every day.",
    service: "Educational Cleaning",
  },
  {
    id: "41-crisp-street-apartments",
    image: "/assets/images/projects/41-crisp-street-apartments/default.jpeg",
    images: [
      "/assets/images/projects/41-crisp-street-apartments/1.jpeg",
      "/assets/images/projects/41-crisp-street-apartments/2.jpeg",
      "/assets/images/projects/41-crisp-street-apartments/3.jpeg",
      "/assets/images/projects/41-crisp-street-apartments/4.jpeg",
      "/assets/images/projects/41-crisp-street-apartments/5.jpeg",
      "/assets/images/projects/41-crisp-street-apartments/6.jpeg",
    ],
    title: "41 Crisp Street Apartment Cleaning",
    description:
      "At Clear Choice, we provide reliable and thorough cleaning services for 41 Crisp Street Apartments twice a week, ensuring a clean and comfortable living environment for residents.",
    subtitle: "Our comprehensive cleaning services include:",
    tasks: [
      {
        task: "General Cleaning",
        description:
          "Keeping all common and private areas tidy and well-organized.",
      },
      {
        task: "Vacuuming and Mopping",
        description:
          "Maintaining spotless and polished floors throughout the apartments.",
      },
      {
        task: "Surface Wiping",
        description:
          "Sanitizing countertops, furniture, and other high-touch areas.",
      },
      {
        task: "Bowl Cleaning",
        description: "Ensuring bathrooms are hygienic and sparkling clean.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "Keeping kitchen spaces clean, sanitary, and ready for use.",
      },
      {
        task: "Sweeping",
        description:
          "Removing debris from floors, hallways, and outdoor areas.",
      },
      {
        task: "Collecting Bins",
        description:
          "Managing waste disposal and ensuring bins are emptied and sanitized.",
      },
      {
        task: "Window Cleaning",
        description:
          "Delivering streak-free windows to enhance the apartment's brightness and views.",
      },
    ],
    bottomText:
      "With our professional cleaning services, 41 Crisp Street Apartments remain a pristine and inviting space for all residents.",
    service: "Residential Cleaning",
  },
  {
    id: "acrodyne-warehouse",
    images: [
      "/assets/images/projects/acrodyne-warehouse/1.jpeg",
      "/assets/images/projects/acrodyne-warehouse/2.jpeg",
      "/assets/images/projects/acrodyne-warehouse/3.jpeg",
      "/assets/images/projects/acrodyne-warehouse/4.jpeg",
      "/assets/images/projects/acrodyne-warehouse/5.jpeg",
      "/assets/images/projects/acrodyne-warehouse/6.jpeg",
    ],
    title: "Acrodyne Warehouse Cleaning",
    description:
      "At Clear Choice, we specialize in maintaining clean, safe, and efficient workspaces. We provide daily cleaning services for the Acrodyne Warehouse in Bayswater, ensuring a spotless environment that supports productivity and professionalism.",
    subtitle: "Our comprehensive cleaning services include:",
    tasks: [
      {
        task: "General Cleaning",
        description:
          "Keeping all areas organized and free from dust and debris.",
      },
      {
        task: "Vacuuming and Mopping",
        description:
          "Ensuring floors are clean, polished, and safe for employees and visitors.",
      },
      {
        task: "Surface Wiping",
        description:
          "Sanitizing workstations, shelves, and frequently touched surfaces.",
      },
      {
        task: "Bowl Cleaning",
        description: "Maintaining hygienic restroom facilities.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "Ensuring breakroom and kitchen areas are clean and ready for use.",
      },
      {
        task: "Sweeping",
        description:
          "Clearing debris from floors and warehouse zones to maintain safety and cleanliness.",
      },
      {
        task: "Collecting Bins",
        description:
          "Managing waste disposal efficiently to support a clutter-free environment.",
      },
      {
        task: "Window Cleaning",
        description:
          "Keeping windows spotless for a brighter, more inviting space.",
      },
    ],
    bottomText:
      "Our daily commitment ensures the Acrodyne Warehouse operates in a clean and professional setting, meeting the highest standards of hygiene and maintenance.",
    service: "Warehouse Cleaning",
  },
  {
    id: "dindas-clayton-warehouse",
    images: [
      "/assets/images/projects/dindas-clayton-warehouse/1.jpeg",
      "/assets/images/projects/dindas-clayton-warehouse/2.jpeg",
      "/assets/images/projects/dindas-clayton-warehouse/3.jpeg",
      "/assets/images/projects/dindas-clayton-warehouse/4.jpeg",
      "/assets/images/projects/dindas-clayton-warehouse/5.jpeg",
      "/assets/images/projects/dindas-clayton-warehouse/6.jpeg",
    ],
    title: "Dindas Clayton Warehouse Cleaning",
    description:
      "At Clear Choice, we understand the importance of a clean and organized workspace. We provide daily cleaning services for the Dindas Clayton Warehouse, ensuring a hygienic and efficient environment for your team and operations.",
    subtitle: "Our cleaning services include:",
    tasks: [
      {
        task: "General Cleaning",
        description:
          "Keeping all areas neat, organized, and free from dust and debris.",
      },
      {
        task: "Vacuuming and Mopping",
        description:
          "Ensuring spotless and polished floors for safety and professionalism.",
      },
      {
        task: "Surface Wiping",
        description:
          "Sanitizing desks, equipment, and frequently touched surfaces.",
      },
      {
        task: "Bowl Cleaning",
        description: "Maintaining clean and hygienic restroom facilities.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "Keeping kitchen and breakroom areas spotless and ready for use.",
      },
      {
        task: "Sweeping",
        description:
          "Clearing debris from floors and high-traffic areas to ensure a safe workspace.",
      },
      {
        task: "Collecting Bins",
        description:
          "Managing waste disposal efficiently for a clutter-free environment.",
      },
      {
        task: "Window Cleaning",
        description:
          "Delivering streak-free, clear windows to brighten the warehouse.",
      },
    ],
    bottomText:
      "With our dedicated daily cleaning services, Dindas Clayton Warehouse stays clean, organized, and ready for smooth operations every day.",
    service: "Warehouse Cleaning",
  },
  {
    id: "emerald-hotel",
    images: [
      "/assets/images/projects/emerald-hotel/1.jpeg",
      "/assets/images/projects/emerald-hotel/2.jpeg",
      "/assets/images/projects/emerald-hotel/3.jpeg",
      "/assets/images/projects/emerald-hotel/4.jpeg",
      "/assets/images/projects/emerald-hotel/5.jpeg",
      "/assets/images/projects/emerald-hotel/6.jpeg",
    ],
    title: "Emerald Hotel Cleaning",
    description:
      "At Clear Choice, we take pride in maintaining the Emerald Hotel’s welcoming and polished appearance with our professional daily cleaning services. Our team ensures every corner of the hotel is spotless, creating a comfortable and enjoyable environment for guests and staff alike.",
    subtitle: "Our comprehensive cleaning services include:",
    tasks: [
      {
        task: "General Cleaning",
        description:
          "Keeping all spaces tidy, fresh, and inviting for guests and staff.",
      },
      {
        task: "Vacuuming and Mopping",
        description:
          "Ensuring floors are clean, polished, and free from dirt or stains.",
      },
      {
        task: "Surface Wiping",
        description:
          "Sanitizing tables, countertops, and frequently touched surfaces throughout the hotel.",
      },
      {
        task: "Bowl Cleaning",
        description: "Maintaining sparkling, hygienic restroom facilities.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "Ensuring the kitchen areas meet the highest standards of cleanliness and hygiene.",
      },
      {
        task: "Sweeping",
        description:
          "Clearing debris from indoor and outdoor spaces, including entrance areas.",
      },
      {
        task: "Collecting Bins",
        description:
          "Efficiently managing waste disposal to maintain a clutter-free environment.",
      },
      {
        task: "Bar Cleaning",
        description:
          "Keeping the bar area pristine, with spotless counters, sinks, and drink stations, ensuring a pleasant experience for patrons.",
      },
      {
        task: "Window Cleaning",
        description:
          "Delivering streak-free, clear windows to brighten the hotel and enhance its appeal.",
      },
    ],
    bottomText:
      "Our daily commitment to excellence ensures the Emerald Hotel maintains its reputation for cleanliness, comfort, and exceptional hospitality.",
    service: "Hotel Cleaning",
  },
  {
    id: "warrandyte-cemetery",
    image: "/assets/images/projects/warrandyte-cemetery/default.jpeg",
    images: [
      "/assets/images/projects/warrandyte-cemetery/1.jpeg",
      "/assets/images/projects/warrandyte-cemetery/2.jpeg",
      "/assets/images/projects/warrandyte-cemetery/3.jpeg",
      "/assets/images/projects/warrandyte-cemetery/4.jpeg",
      "/assets/images/projects/warrandyte-cemetery/5.jpeg",
      "/assets/images/projects/warrandyte-cemetery/6.jpeg",
    ],
    title: "Warrandyte Cemetery Cleaning",
    description:
      "At Clear Choice, we take pride in maintaining the serene and respectful environment of Warrandyte Cemetery. Our dedicated team ensures the space is impeccably clean and welcoming for visitors and staff.",
    subtitle:
      "We provide comprehensive cleaning services three days a week, focusing on all key areas, including:",
    tasks: [
      {
        task: "General Cleaning",
        description: "Ensuring all surfaces are spotless and tidy.",
      },
      {
        task: "Vacuuming and Mopping",
        description: "Keeping floors pristine and free from dust or stains.",
      },
      {
        task: "Surface Wiping",
        description:
          "Thoroughly cleaning countertops, benches, and other high-touch areas.",
      },
      {
        task: "Bowl Cleaning",
        description: "Sanitizing restroom facilities for optimal hygiene.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "Ensuring a clean and functional kitchen area for staff or visitors.",
      },
      {
        task: "Window Cleaning",
        description:
          "Maintaining clear and streak-free windows for a bright and welcoming atmosphere.",
      },
    ],
    bottomText:
      "Our professional approach ensures Warrandyte Cemetery remains a peaceful and well-kept space, reflecting the dignity and care it deserves.",
    service: "Office Cleaning",
  },
  {
    id: "templestowe-cemetery",
    image: "/assets/images/projects/templestowe-cemetery/default.jpeg",
    images: [
      "/assets/images/projects/templestowe-cemetery/1.jpeg",
      "/assets/images/projects/templestowe-cemetery/2.jpeg",
      "/assets/images/projects/templestowe-cemetery/3.jpeg",
      "/assets/images/projects/templestowe-cemetery/4.jpeg",
      "/assets/images/projects/templestowe-cemetery/5.jpeg",
      "/assets/images/projects/templestowe-cemetery/6.jpeg",
    ],
    title: "Templestowe Cemetery Cleaning",
    description:
      "At Clear Choice, we are committed to preserving the tranquil and respectful environment of Templestowe Cemetery. Our professional team ensures the grounds and facilities remain clean and welcoming for all visitors and staff.",
    subtitle:
      "We perform comprehensive cleaning services three days a week, covering:",
    tasks: [
      {
        task: "General Cleaning",
        description: "Keeping all areas neat, organized, and spotless.",
      },
      {
        task: "Vacuuming and Mopping",
        description: "Maintaining clean and polished floors throughout.",
      },
      {
        task: "Surface Wiping",
        description:
          "Sanitizing countertops, benches, and frequently touched surfaces.",
      },
      {
        task: "Bowl Cleaning",
        description:
          "Ensuring restroom facilities are hygienic and well-maintained.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "Providing a clean and sanitary kitchen area for staff or visitor use.",
      },
      {
        task: "Window Cleaning",
        description:
          "Delivering streak-free, crystal-clear windows for a bright and inviting atmosphere.",
      },
    ],
    bottomText:
      "With meticulous attention to detail, we ensure Templestowe Cemetery is a serene and well-kept space, reflecting the respect and dignity it deserves.",
    service: "Office Cleaning",
  },
  {
    id: "westfield-doncaster",
    images: [
      "/assets/images/projects/westfield-doncaster/1.jpeg",
      "/assets/images/projects/westfield-doncaster/2.jpeg",
      "/assets/images/projects/westfield-doncaster/3.jpeg",
      "/assets/images/projects/westfield-doncaster/4.jpeg",
      "/assets/images/projects/westfield-doncaster/5.jpeg",
      "/assets/images/projects/westfield-doncaster/6.jpeg",
    ],
    title: "Westfield Shopping Centre Cleaning",
    description:
      "At Clear Choice, we are proud to provide professional daily cleaning services for Westfield Shopping Centre in Doncaster. Our team is dedicated to maintaining the centre’s pristine appearance, ensuring a clean and inviting space for shoppers, staff, and retailers.",
    subtitle: "Our comprehensive cleaning services include:",
    tasks: [
      {
        task: "General Cleaning",
        description:
          "Keeping all common areas tidy, well-organized, and welcoming for visitors.",
      },
      {
        task: "Vacuuming and Mopping",
        description:
          "Maintaining spotless and polished floors to enhance safety and aesthetics.",
      },
      {
        task: "Surface Wiping",
        description:
          "Sanitizing countertops, benches, seating areas, and high-touch surfaces throughout the centre.",
      },
      {
        task: "Bowl Cleaning",
        description:
          "Ensuring hygienic and well-maintained restroom facilities.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "Keeping staff kitchen and food court areas clean and sanitary for a pleasant dining experience.",
      },
      {
        task: "Sweeping",
        description:
          "Clearing debris from indoor pathways, outdoor entryways, and high-traffic areas.",
      },
      {
        task: "Collecting Bins",
        description:
          "Efficient waste management and bin sanitization to support cleanliness across the centre.",
      },
      {
        task: "Window Cleaning",
        description:
          "Providing streak-free, gleaming windows that enhance the centre’s brightness and appeal.",
      },
      {
        task: "Attention to Detail",
        description:
          "Special focus on high-traffic zones such as entrances, escalators, food courts, and retail corridors to maintain a premium shopping experience.",
      },
    ],
    bottomText:
      "Our commitment to excellence ensures Westfield Shopping Centre Doncaster remains a top destination for shoppers and a well-maintained space that retailers can be proud of.",
    service: "Commercial Cleaning",
  },
  {
    id: "dingley-village-woolworths",
    images: [
      "/assets/images/projects/dingley-village-woolworths/1.jpeg",
      "/assets/images/projects/dingley-village-woolworths/2.jpeg",
      "/assets/images/projects/dingley-village-woolworths/3.jpeg",
      "/assets/images/projects/dingley-village-woolworths/4.jpeg",
      "/assets/images/projects/dingley-village-woolworths/5.jpeg",
      "/assets/images/projects/dingley-village-woolworths/6.jpeg",
    ],
    title: "Dingley Village Woolworths Cleaning",
    description:
      "At Clear Choice, we ensure that Dingley Village Woolworths maintains the highest standards of cleanliness and hygiene with our dedicated daily cleaning services. Our professional team works diligently to create a spotless, safe, and welcoming shopping environment for customers and staff.",
    subtitle: "Our comprehensive cleaning services include:",
    tasks: [
      {
        task: "General Cleaning",
        description:
          "Keeping all areas neat, organized, and free from dust and debris.",
      },
      {
        task: "Vacuuming and Mopping",
        description:
          "Ensuring spotless, polished floors to enhance safety and appearance.",
      },
      {
        task: "Surface Wiping",
        description:
          "Sanitizing high-touch areas such as counters, shelves, and customer service zones.",
      },
      {
        task: "Bowl Cleaning",
        description:
          "Maintaining hygienic and fresh restroom facilities for staff and shoppers.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "Keeping staff kitchen and food preparation areas clean and sanitary.",
      },
      {
        task: "Sweeping",
        description:
          "Removing debris from floors, entryways, and high-traffic zones for a tidy environment.",
      },
      {
        task: "Collecting Bins",
        description:
          "Managing waste disposal efficiently to maintain a clutter-free shopping space.",
      },
      {
        task: "Floor Scrubbing",
        description:
          "Deep cleaning and scrubbing of floors to remove stubborn stains and maintain a gleaming finish.",
      },
      {
        task: "Window Cleaning",
        description:
          "Providing streak-free windows that enhance natural light and the store’s overall appeal.",
      },
    ],
    bottomText:
      "Our meticulous approach and commitment to excellence make Dingley Village Woolworths a pristine and inviting space for daily shoppers while supporting efficient store operations.",
    service: "Retail Cleaning",
  },
  {
    id: "pressure-washing-services-cranbourne",
    image:
      "/assets/images/projects/pressure-washing-services-cranbourne/default.jpeg",
    images: [
      "/assets/images/projects/pressure-washing-services-cranbourne/1.jpeg",
      "/assets/images/projects/pressure-washing-services-cranbourne/2.jpeg",
      "/assets/images/projects/pressure-washing-services-cranbourne/3.jpeg",
      "/assets/images/projects/pressure-washing-services-cranbourne/4.jpeg",
      "/assets/images/projects/pressure-washing-services-cranbourne/5.jpeg",
      "/assets/images/projects/pressure-washing-services-cranbourne/6.jpeg",
    ],
    title: "Professional Pressure Washing Services in Cranbourne",
    description:
      "At Clear Choice, we deliver top notch pressure washing services tailored to meet the unique needs of our customers. Recently, we completed a detailed pressure washing project in Cranbourne, where we transformed the appearance of a customer’s driveways and footpaths while expertly preparing their concrete floors for repainting.",
    subtitle: "Our comprehensive cleaning services include:",
    tasks: [
      {
        task: "Driveway and Footpath Cleaning",
        description:
          "We used high-pressure cleaning equipment to remove dirt, grime, and stains from the driveways and all surrounding footpaths, restoring them to their original clean and polished condition.",
      },
      {
        task: "Paint Removal from Concrete",
        description:
          "The customer required complete paint removal to prepare the concrete surface for a fresh coat of paint. Our team expertly removed all traces of old paint without damaging the underlying concrete.",
      },
      {
        task: "Surface Preparation for Repainting",
        description:
          "By thoroughly cleaning and smoothing the concrete, we ensured an ideal surface for the customer’s repainting project, enhancing the durability and appearance of the new paint.",
      },
      {
        task: "Efficient and Timely Service",
        description:
          "We worked within the customer’s timeframe, completing the job promptly and leaving the area spotless.",
      },
      {
        task: "Environmentally Friendly Practices",
        description:
          "We used eco-friendly techniques to minimize water usage and avoid the release of harmful chemicals.",
      },
      {
        task: "Expertise in Paint Removal",
        description:
          "We specialize in preparing concrete surfaces for repainting, ensuring a flawless finish.",
      },
      {
        task: "Advanced Equipment",
        description:
          "Our high-pressure washers are designed to tackle even the toughest stains and paint layers.",
      },
      {
        task: "Attention to Detail",
        description:
          "We guarantee a thorough cleaning that leaves your driveways and footpaths looking refreshed and ready for any project.",
      },
      {
        task: "Customer Satisfaction",
        description:
          "Our team prioritizes delivering exceptional results that exceed expectations.",
      },
    ],
    bottomText:
      "Whether you need driveways, footpaths, or other concrete surfaces cleaned or prepped for repainting, our pressure washing services are the perfect solution. Trust us to provide the highest quality cleaning in Cranbourne.",
    service: "Home Cleaning",
  },
  {
    id: "22-ann-st-dandenong-house",
    image: "/assets/images/projects/22-ann-st-dandenong-house/default.jpeg",
    images: [
      "/assets/images/projects/22-ann-st-dandenong-house/1.jpeg",
      "/assets/images/projects/22-ann-st-dandenong-house/2.jpeg",
      "/assets/images/projects/22-ann-st-dandenong-house/3.jpeg",
      "/assets/images/projects/22-ann-st-dandenong-house/4.jpeg",
      "/assets/images/projects/22-ann-st-dandenong-house/5.jpeg",
      "/assets/images/projects/22-ann-st-dandenong-house/6.jpeg",
    ],
    title: "22 Ann St Dandenong House Cleaning Services",
    description:
      "The team delivered exceptional results, leaving the entire kitchen area thoroughly cleaned and well-maintained.",
    subtitle: "Key Highlights of the Project",
    tasks: [
      {
        task: "Oven Cleaning",
        description:
          "We meticulously cleaned the oven, removing grease, food residue, and built-up grime, ensuring it was restored to a pristine condition.",
      },
      {
        task: "Gas Cookers Cleaning",
        description:
          "Our team expertly cleaned the gas cooktops, removing stubborn stains and grease to keep them sparkling and functioning efficiently.",
      },
      {
        task: "Range Hood Cleaning",
        description:
          "We thoroughly cleaned the range hood, removing grease and buildup to ensure proper ventilation and a fresh-smelling kitchen.",
      },
      {
        task: "Sink and Basin Cleaning",
        description:
          "The sink area was thoroughly cleaned, with all surfaces scrubbed and sanitized to remove stains, residue, and soap scum.",
      },
      {
        task: "Cupboard Cleaning",
        description:
          "We carefully wiped down and organized all kitchen cupboards, removing dust, spills, and stains to ensure a clean, clutter-free space.",
      },
      {
        task: "Window Cleaning",
        description:
          "The kitchen windows were cleaned inside and out, leaving them streak-free and allowing natural light to brighten the space.",
      },
      {
        task: "Benchtop Cleaning",
        description:
          "All benchtops were wiped down and sanitized, ensuring surfaces were free of food stains, crumbs, and bacteria.",
      },
    ],
    bottomText:
      "Whether it's a routine kitchen clean or a deep, detailed clean like the one at 22 Ann St, Dandenong, trust us to deliver a kitchen that is fresh, clean, and ready for use.",
    service: "Home Cleaning",
  },
  {
    id: "eye-scan-toorak-office",
    image: "/assets/images/projects/eye-scan-toorak-office/default.jpeg",
    images: [
      "/assets/images/projects/eye-scan-toorak-office/1.jpeg",
      "/assets/images/projects/eye-scan-toorak-office/2.jpeg",
      "/assets/images/projects/eye-scan-toorak-office/3.jpeg",
      "/assets/images/projects/eye-scan-toorak-office/4.jpeg",
      "/assets/images/projects/eye-scan-toorak-office/5.jpeg",
      "/assets/images/projects/eye-scan-toorak-office/6.jpeg",
    ],
    title: "Eye Scan Toorak Office Cleaning Services",
    description:
      "At Clear Choice, we are dedicated to maintaining a clean and professional environment at Eye Scan Toorak with our comprehensive office cleaning services. Our team ensures that the office space remains spotless, hygienic, and welcoming for both staff and clients.",
    subtitle: "Our Office Cleaning Services Include:",
    tasks: [
      {
        task: "General Cleaning",
        description:
          "We ensure all areas of the office are consistently neat, organized, and free of clutter.",
      },
      {
        task: "Vacuuming and Mopping",
        description:
          "Floors are vacuumed and mopped to remove dirt, dust, and debris, maintaining a polished, safe environment.",
      },
      {
        task: "Surface Wiping",
        description:
          "We sanitize desks, countertops, and other high-touch surfaces to reduce germs and keep the office hygienic.",
      },
      {
        task: "Bowl Cleaning",
        description:
          "Restroom facilities are thoroughly cleaned and sanitized for a fresh, hygienic experience for staff and visitors.",
      },
      {
        task: "Kitchen Cleaning",
        description:
          "The kitchen area is cleaned, ensuring that appliances, countertops, and sinks are sanitized and ready for use.",
      },
      {
        task: "Sweeping",
        description:
          "We ensure that floors and entryways are free from dirt and debris, creating a safe, clean environment.",
      },
      {
        task: "Collecting Bins",
        description:
          "Waste management is efficiently handled, with bins emptied and areas cleared of waste.",
      },
      {
        task: "Window Cleaning",
        description:
          "We deliver streak-free windows that enhance natural light and contribute to a bright, welcoming office atmosphere.",
      },
    ],
    bottomText:
      "With our attention to detail and commitment to excellence, our team ensures that Eye Scan Toorak is always a clean, professional, and comfortable space for both patients and staff.",
    service: "Office Cleaning",
  },
  {
    id: "anytime-fitness-gym-cleaning",
    image: "/assets/images/projects/anytime-fitness-gym-cleaning/default.jpeg",
    images: [
      "/assets/images/projects/anytime-fitness-gym-cleaning/1.jpeg",
      "/assets/images/projects/anytime-fitness-gym-cleaning/2.jpeg",
      "/assets/images/projects/anytime-fitness-gym-cleaning/3.jpeg",
      "/assets/images/projects/anytime-fitness-gym-cleaning/4.jpeg",
      "/assets/images/projects/anytime-fitness-gym-cleaning/5.jpeg",
      "/assets/images/projects/anytime-fitness-gym-cleaning/6.jpeg",
    ],
    title: "Professional Gym Cleaning Services at Anytime Fitness",
    description:
      "Our cleaning company ensures that Anytime Fitness stays spotless, hygienic, and inviting for every member. We understand the importance of maintaining a clean and healthy environment for fitness enthusiasts, focusing on high-touch areas and specialized equipment cleaning.",
    subtitle: "Our Gym Cleaning Services Include:",
    tasks: [
      {
        task: "Thorough Equipment Cleaning",
        description:
          "We sanitize gym equipment, weights, and machines to ensure a germ-free workout experience.",
      },
      {
        task: "High-Touch Surface Disinfection",
        description:
          "Handles, benches, door knobs, and other frequently touched areas are cleaned with precision to reduce the spread of germs.",
      },
      {
        task: "Shower and Locker Room Sanitization",
        description:
          "We provide deep cleaning for showers, lockers, and change rooms, leaving them fresh and safe for all members.",
      },
      {
        task: "Floor Maintenance",
        description:
          "From vacuuming carpets to mopping hard floors, we ensure the gym flooring is spotless and safe for workout activities.",
      },
      {
        task: "Odor Control",
        description:
          "Our cleaning methods eliminate odors, maintaining a fresh and welcoming gym atmosphere for all members.",
      },
      {
        task: "Custom Cleaning Schedules",
        description:
          "Cleaning services are tailored to suit gym operating hours, ensuring minimal disruption and maximum convenience for members.",
      },
      {
        task: "Eco-Friendly Practices",
        description:
          "We use environmentally safe cleaning products to promote a healthier and safer workout space.",
      },
      {
        task: "Waste Management",
        description:
          "Timely removal of trash and replenishment of hygiene supplies in restrooms to ensure a clean, comfortable environment.",
      },
      {
        task: "Emergency Spill Cleanup",
        description:
          "Our team provides rapid response to accidental spills, ensuring the gym remains safe and hygienic at all times.",
      },
      {
        task: "Compliance with Health Standards",
        description:
          "Our services align with industry health and safety regulations, ensuring a safe and sanitary environment for all members.",
      },
    ],
    bottomText:
      "With a focus on cleanliness and member safety, we ensure Anytime Fitness remains a hygienic, welcoming environment where members can focus on their fitness goals without distractions.",
    service: "Gym Cleaning",
  },
];

export const comparisons = [
  {
    id: 1,
    before: "/assets/images/banners/contact.webp",
    after: "/assets/images/banners/contact.webp",
  },
  {
    id: 2,
    before: "/assets/images/banners/contact.webp",
    after: "/assets/images/banners/contact.webp",
  },
  {
    id: 3,
    before: "/assets/images/banners/contact.webp",
    after: "/assets/images/banners/contact.webp",
  },
  {
    id: 4,
    before: "/assets/images/banners/contact.webp",
    after: "/assets/images/banners/contact.webp",
  },
  {
    id: 5,
    before: "/assets/images/banners/contact.webp",
    after: "/assets/images/banners/contact.webp",
  },
  {
    id: 6,
    before: "/assets/images/banners/contact.webp",
    after: "/assets/images/banners/contact.webp",
  },
  {
    id: 7,
    before: "/assets/images/banners/contact.webp",
    after: "/assets/images/banners/contact.webp",
  },
  {
    id: 8,
    before: "/assets/images/banners/contact.webp",
    after: "/assets/images/banners/contact.webp",
  },
];

export function getRandomItems(arr, num) {
  // Shuffle the array
  const shuffledArray = arr.sort(() => 0.5 - Math.random());

  // Return the first 'num' items
  return shuffledArray.slice(0, num);
}

export function getRandomItemsWithoutId(array, excludeId, count) {
  // Filter out the item with the excluded id
  const filteredArray = array.filter((item) => item.id !== excludeId);

  // Shuffle the filtered array
  const shuffledArray = filteredArray.sort(() => Math.random() - 0.5);

  // Return the first 'count' items from the shuffled array
  return shuffledArray.slice(0, count);
}
